import {Platform} from 'react-native';

const configuredUrl = (globalThis as any).process?.env?.EXPO_PUBLIC_SERVER_URL?.replace(/\/$/, '');
const webHost = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
const isLocalWeb = typeof window !== 'undefined' && ['localhost','127.0.0.1'].includes(window.location.hostname);

// Web follows the machine serving Expo. For a physical phone, provide the
// computer LAN address through EXPO_PUBLIC_SERVER_URL before starting Expo.
export const SERVER_URL = configuredUrl || (Platform.OS === 'web'
  ? (isLocalWeb ? `http://${webHost}:3000` : window.location.origin)
  : 'http://localhost:3000');
